/**
 * What a Community Fibre customer is told about the installation. Community
 * Fibre's own crew connect the service in the apartment and arrange the
 * visit with the customer directly; Pineapple do not manage that
 * appointment, which is the only sense in which it is "remote" from here.
 * The customer must never be told nobody is coming.
 */
export const CF_CONNECTION_DATE_COPY = 'Pineapple Net uses the Community '
  + 'Fibre network, which operates independently of the nbn and other '
  + 'internet providers in your building. To get you connected, one of '
  + 'Community Fibre’s installation partners will need to visit your '
  + 'apartment to complete the installation. This typically takes around '
  + '45–60 minutes, and you\'ll need to be home for the appointment.';
